import React from 'react'
import ProjectChartLow from './projectChartLow/ProjectChartLow'

const ProjectCardLow = () => {
    return (
        <div className='w-full h-fit text-sm font-color-4 flex flex-col'>
            <div className='flex-1 justify-between items-center'>
                <div className=''>Flop 10</div>
                <div className='text-sm font-color-6 py-2'>Die zehn schlechtesten Projekte</div>
                <div
                    className='max-h-chart-scroll scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200 overflow-y-auto relative'>
                    <ProjectChartLow />
                </div>
            </div>
        </div>
    );
};



export default ProjectCardLow